import React from 'react';
import { Archive } from 'lucide-react';
import { ARCHIVED_LEAGUE_BANNER_COPY } from '../lifecycle';

const ArchivedLeagueBanner: React.FC = () => (
  <div
    className="rounded-lg border border-amber-800/60 bg-amber-950/40 px-4 py-3 text-sm text-amber-100 flex gap-3 items-start"
    role="status"
    data-testid="archived-league-banner"
  >
    <Archive className="h-4 w-4 shrink-0 mt-0.5 text-amber-300" aria-hidden />
    <p>{ARCHIVED_LEAGUE_BANNER_COPY}</p>
  </div>
);

export default ArchivedLeagueBanner;
